var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-player-container"},[_c('video',{ref:"videoPlayer",staticClass:"responsive-video video-js vjs-big-play-centered",attrs:{"data-setup":"{}"}})])}
var staticRenderFns = []

export { render, staticRenderFns }